import "core-js/modules/es6.function.name";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import JsDocBlock from './JsDocBlock';
import JsDocTitleSignature from './JsDocTitleSignature';
import LinkedHeading from './LinkedHeading';
import TsDocBlock from './TsDocBlock';
import TsDocTitleSignature from './TsDocTitleSignature';
import jsDocTypeExpression from './utils/jsDocTypeExpression';
import tsDocTypeExpression, { getParams } from './utils/tsDocTypeExpression';

var styles = require('./HookSignature-styles.module.css');

function getTitle(jsDoc, tsDoc) {
  if (jsDoc) {
    var _jsDoc$returns;

    var _params = jsDoc.params ? jsDoc.params.map(function (param) {
      var type = param.type && "" + (param.optional ? '?' : '');
      return "" + param.name + (type || '');
    }) : [];

    var _returns = ((_jsDoc$returns = jsDoc.returns) === null || _jsDoc$returns === void 0 ? void 0 : _jsDoc$returns.length) ? jsDocTypeExpression(jsDoc.returns[0].type) : 'void';

    return "\u0192 (" + _params.join(', ') + ") => " + _returns;
  } // TODO: maybe?
  // const typeParams = tsDoc.typeParameter?.map(p => p.name);


  var params = getParams(tsDoc, {
    includeTypes: false
  });
  var returns = tsDoc.type ? tsDocTypeExpression(tsDoc.type) : 'void';
  return "\u0192 (" + params.join(', ') + ") => " + returns;
}

function HookSignature(_ref) {
  var jsDocType = _ref.jsDocType,
      tsDocType = _ref.tsDocType,
      level = _ref.level;
  var title = getTitle(jsDocType, tsDocType);
  return _j("li", {
    className: styles.HookSignature
  }, _j(LinkedHeading, {
    id: title,
    title: title,
    h: level,
    css: [require("./HookSignature-CssProp1_LinkedHeading.module.css"), []]
  }, _j("span", {
    className: styles.count
  }), tsDocType && _j(TsDocTitleSignature, {
    definition: tsDocType
  }), jsDocType && _j(JsDocTitleSignature, {
    definition: jsDocType
  })), _j("div", null, tsDocType && _j(TsDocBlock, {
    depth: level,
    definition: tsDocType
  }), jsDocType && _j(JsDocBlock, {
    depth: level,
    definition: jsDocType
  })));
}

export default HookSignature;